import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';

import { ensureArray } from 'cityads-v3/utils/arrayUtils';
import config from 'cityads-v3/config';

import {
  USER_ROLE_CODE_MANAGER,
  USER_ROLE_CODE_ADVERTISER,
  USER_ROLE_CODE_WEBMASTER,
} from 'cityads-v3/reducers/auth';

export const ALLOWED_PATHS = [
  'register/publisher',
  'register/advertiser',
  'register/blogger',
  'auth'
];

@withTranslation(['main'], { i18n, wait: !!window })
export default class StartWorkButton extends PureComponent {
  static propTypes = {
    label       : PropTypes.string,
    user        : PropTypes.object,
    currentPath : PropTypes.string,
    userRoleCode: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    registerAs  : PropTypes.string,
    t           : PropTypes.func
  };

  render() {
    const { label, user, currentPath, userRoleCode, registerAs, t, tReady, i18n, i18nLoadedAt, ...otherProps } = this.props;

    let buttonProps = {};
    let alreadyAuthorizedLabel = null;

    if (user) {
      buttonProps.href = `${config.AUTH_URL}/enter`;
      buttonProps.rel  = 'nofollow';

      if (!ensureArray(userRoleCode).includes(user.user_role_code)) {
        alreadyAuthorizedLabel = t('alreadyAuthorisedAs', {
          as: user.user_role_code
            .replace(USER_ROLE_CODE_MANAGER, t('manager'))
            .replace(USER_ROLE_CODE_WEBMASTER, t('publisher'))
            .replace(USER_ROLE_CODE_ADVERTISER, t('advertiser'))
        });
      }
    } else {
      buttonProps.component = Link;
      buttonProps.to        = `${currentPath}/register/${registerAs}`;
    }

    return (
      <Button
        variant = "contained"
        color = "primary"
        {...otherProps}
        {...buttonProps}
      >
        {alreadyAuthorizedLabel || label || t('startWorkButton')}
      </Button>
    );
  }
}
